/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import NavBar from "../components/global/NavBar";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import beginner from "../components/images/beginner.gif"
import beginner2 from "../components/images/beginner2.gif"
import beginner3 from "../components/images/beginner3.gif"
import beginnerUploadingARFF from "../components/images/beginnerUploadingARFF.gif"
import beginnerUploadingTXT from "../components/images/beginnerUploadingTXT.gif"
import  compare1 from "../components/images/compare1.gif"
import  compare2 from "../components/images/compare2.gif"
import  compare3 from "../components/images/compare3.gif"
import  classifyRule from "../components/images/classifyRule.gif"
import  classifyTree from "../components/images/classifyTree.gif"
import  selectExpert from "../components/images/selectExpert.gif"
import  cretingDataset from "../components/images/cretingDataset.gif"
import  selectDatasetCreated from "../components/images/selectDatasetCreated.gif"


import {
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ListItemIcon
} from "@material-ui/core";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ListItemText from "@material-ui/core/ListItemText";
import Link from "@material-ui/core/Link";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";

const styles = theme => ({
  padding: {
    paddingTop: 64,
    marginBottom:100,
  },
  imgPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  expansionPanelDetails: {
    display: "block"
  },
  img: {
    maxWidth: "1200px",
    maxHeight: "700px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%"
    }
  },
  button: {
    marginTop: 10,
    maringBottom: 10,
    width: "60%",
    margin: "auto"
  },
  innerPanel: {
    margin: 10
  },
  leftLogos: {
    height: 36,
    marginTop: 20,
    marginBottom: 20
  },
  rightLogos: {
    height: 60,
    marginTop: 20,
    marginBottom: 20
  },
  footer:{
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    display:"inline-table",
    justifyContent:"space-evenly",
    position:"fixed",
    bottom:0,
    height:100,
    left:0,
    width:"100%",
    backgroundColor:"white",
  },
  centerFotter:{
    display:"flex",
    justifyContent:"space-evenly",
  },
});

class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tutorial1: false,
      tutorial2A: false,
      tutorial2B: false,
      tutorial3: false,
      tutorial4: false
    };
  }

  getModalStyle() {
    const top = 25;

    return {
      top: `${top}%`,
      margin: "auto",
      marginTop: 100,
      textAlign: "center",
      outline: "none"
    };
  }

  openTutorial = tutorial => {
    this.setState({
      [tutorial]: true
    });
  };

  closeTutorial = tutorial => {
    this.setState({
      [tutorial]: false
    });
  };

  render() {
    console.log(this.props.language)
    const { classes } = this.props;

    return (
        <Fragment>
          <NavBar
              language={this.props.language}
              handleLanguageChange={this.props.handleLanguageChange}
          />
          <Grid container justify="center" className={classes.padding}>
            <Grid item xs={12}>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h3">{this.props.language.labels[this.props.language.id].titleHelp1}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Typography variant="body1">
                    {this.props.language.labels[this.props.language.id].helpMessage1}{" "}
                    <Link  target="_blank" rel="noopener" href="https://www.cs.waikato.ac.nz/ml/weka/">Weka</Link>.
                    {this.props.language.labels[this.props.language.id].helpMessage2}{" "}
                    <Link  target="_blank" rel="noopener" href="https://github.com/simplenlg/simplenlg">SimpleNLG</Link>{" "}
                    {this.props.language.labels[this.props.language.id].helpMessage3}
                  </Typography>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h3">{this.props.language.labels[this.props.language.id].titleHelp2}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp3}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp4}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseBeginner1}
                          </Typography>
                          <img src={beginner} style={{width:"50%",border:"solid black"}} alt="Beginner example" />
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseBeginner2}

                            <Link target={"_blank"} href={"https://www.cs.waikato.ac.nz/ml/weka/arff.html"}>https://www.cs.waikato.ac.nz/ml/weka/arff.html</Link>
                          </Typography>
                          <img src={beginnerUploadingARFF} style={{width:"50%",border:"solid black"}} alt="Beginner example" />
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseBeginner3}
                            <Link target={"_blank"} href={"https://doi.org/10.2991/ijcis.d.200715.003"}>
                              https://doi.org/10.2991/ijcis.d.200715.003
                            </Link>
                          </Typography>
                          <br></br>
                          <img src={beginnerUploadingTXT} style={{width:"50%",border:"solid black"}} alt="Beginner example" />

                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp5}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseBeginner4}
                          </Typography>
                          <img src={beginner2} style={{width:"50%",border:"solid black"}} alt="Begonner example" />
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp6}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseBeginner5}

                          </Typography>
                          <img src={beginner3} style={{width:"50%",border:"solid black"}} alt="Begonner example" />

                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp7}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">
                            {this.props.language.labels[this.props.language.id].titleHelp8}
                          </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            <img src={selectExpert} style={{width:"50%",border:"solid black"}} alt="Select expert" />
                            <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                              {this.props.language.labels[this.props.language.id].howToUseExpert1}
                            </Typography>
                            <img src={selectDatasetCreated} style={{width:"50%",border:"solid black"}} alt="Selecting created dataset" />
                            <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                              {this.props.language.labels[this.props.language.id].howToUseExpert2}
                            </Typography>
                            <img src={cretingDataset} style={{width:"50%",border:"solid black"}} alt="Creating dataset" />

                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp9}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseExpert3}
                          </Typography>
                          <img src={classifyTree} style={{width:"50%",border:"solid black"}} alt="Classify Tree" />
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseExpert4}
                          </Typography>
                          <img src={classifyRule} style={{width:"50%",border:"solid black"}} alt="Classif Rules" />

                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp10}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseExpert5}
                          </Typography>
                          <img src={compare1} style={{width:"50%",border:"solid black"}} alt="Comparing" />
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseExpert6}
                          </Typography>
                          <img src={compare2} style={{width:"50%",border:"solid black"}} alt="Comparing difficulty" />
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].howToUseExpert7}
                          </Typography>
                          <img src={compare3} style={{width:"50%",border:"solid black"}} alt="Comparing explnations" />

                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h3">{this.props.language.labels[this.props.language.id].titleHelp11}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp12}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">J48</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].j48Message1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].j48Message2}
                          </Typography>
                          <br/>
                          <Typography variant="body1" component="list" style={{textAlign: "justify"}}>
                            <List>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href=" https://doi.org/10.1007/BF00116251">
                                    J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.
                                  </Link>
                                </ListItemText>
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText  >
                                  <Link  target="_blank" href="https://www.cs.waikato.ac.nz/ml/weka/book.html">
                                    I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.
                                  </Link>
                                </ListItemText>
                              </ListItem>
                            </List>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">REPTree</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].repTreeMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].repTreeMessage2}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            <List>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://doi.org/10.1007/BF00116251" >
                                    J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.&nbsp;
                                  </Link>
                                </ListItemText>
                              </ListItem>
                              <ListItem >al
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://www.cs.waikato.ac.nz/ml/weka/book.html">
                                    I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.&nbsp;
                                  </Link>
                                </ListItemText>
                              </ListItem>
                            </List>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">RandomTree</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].randomTreeMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].randomTreeMessage2}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            <List>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://doi.org/10.1007/BF00116251">
                                    J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.&nbsp;
                                  </Link>
                                </ListItemText>
                              </ListItem>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://www.cs.waikato.ac.nz/ml/weka/book.html">
                                    https://www.cs.waikato.ac.nz/ml/weka/book.html
                                  </Link>
                                </ListItemText>
                              </ListItem>
                            </List>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">RandomForest</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].randomForestMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].randomForestMessage2}
                            <List>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://doi.org/10.1023/A:1010933404324">
                                    L. Breiman, "Random forests", Machine Learning, 45(1):5–32, 2001.&nbsp;
                                  </Link>
                                </ListItemText>
                              </ListItem>
                            </List>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">FuzzyHoeffdingDecisionTree</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].fuzzyHoeffdingDecisionTreeMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].fuzzyHoeffdingDecisionTreeMessage2}
                            <List>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://doi.org/10.2991/eusflat-19.2019.102">
                                    R. Pecori, P. Ducange, F. Marcelloni, "Incremental learning of fuzzy decision trees for streaming data classification", in 11th Conference of the European Society for Fuzzy Logic and Technology (EUSFLAT), Atlantis Press, 2019.&nbsp;
                                  </Link>
                                </ListItemText>
                              </ListItem>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, pp. 1–8, 2020 &nbsp;
                                </ListItemText>
                              </ListItem>
                            </List>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">FURIA</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].furiaMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].furiaMessage2}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].furiaMessage3}
                            <List>
                              <ListItem >
                                <ListItemIcon>
                                  <FiberManualRecordIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText >
                                  <Link target="_blank" href="https://doi.org/10.1007/s10618-009-0131-8">
                                    J. Huhn and E. Hullermeier, "FURIA: an algorithm for unordered fuzzy rule induction", Data Mining and Knowledge Discovery, 19(3):293–319, 2009.&nbsp;
                                  </Link>
                                </ListItemText>
                              </ListItem>
                            </List>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleHelp13}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Iris</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].irisMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].irisMessage2}

                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            Fisher,R.A. "The use of multiple measurements in taxonomic problems", Annual Eugenics, 7, Part II,
                            179-188 (1936)
                          </Typography>
                          <br/>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Iris">
                              https://archive.ics.uci.edu/ml/datasets/Iris
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Glass</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].glassMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].glassMessage2}
                          </Typography>
                          <br/>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Glass">
                              https://archive.ics.uci.edu/ml/datasets/Glass
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Oulad</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].ouladMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].ouladMessage2}
                            Jose M. Alonso, G. Casalino, "Explainable Artificial Intelligence for Human-Centric Data Analysis in Virtual Learning Environments", in Burgos, D., Cimitile, M., Ducange, P., Pecori, R., Picerno, P., Raviolo, P., Stracke, C.M. (Editors), Higher Education Learning Methodologies and Technologies Online, Springer, pp. 125-138,{" "}
                            <Link target="_blank" href="http://dx.doi.org/10.1007/978-3-030-31284-8_10">
                              http://dx.doi.org/10.1007/978-3-030-31284-8_10
                            </Link>
                          </Typography>
                          <br/>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Pima</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].pimaMesssage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].pimaMessage2}
                            Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, 2020, pp. 1–8,
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].pimaMessage3}
                          </Typography>
                          <br/>
                          <Typography variant="body"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].pimaMessage4}
                            <Link target="_blank" href="https://waikato.github.io/weka-wiki/datasets">
                              https://waikato.github.io/weka-wiki/datasets
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>


                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Bank</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].bankMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].bankMessage2}
                          </Typography>
                          <br/>
                          <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                            Jose M. Alonso, A. Bugarin, "ExpliClas: Automatic Generation of Explanations in Natural Language for Weka Classifiers", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), New Orleans, USA, 2019, pp. 1–6,&nbsp;
                            <Link target="_blank" href="http://dx.doi.org/10.1109%2FFUZZ-IEEE.2019.8859018">
                              http://dx.doi.org/10.1109%2FFUZZ-IEEE.2019.8859018
                            </Link>
                          </Typography>
                          <br/>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Flavia</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].flaviaMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            Jose M. Alonso, A. Ramos-Soto, Ehud Reiter, Kees van Deemter, "An Exploratory Study on the Benefits of using Natural Language for Explaining Fuzzy Rule-based Systems", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Naples, Italy, 2017, pp. 1–6,</Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].flaviaMessage2}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            S. Gang Wu, F. Sheng Bao, E. You Xu, Y.-X. Wang, Y.-F. Chang, and Q.-L. Xiang, "A leaf recognition algorithm for plant classification using probabilistic neural network", in IEEE International Symposium on Signal Processing and Information Technology, 2007, pp. 1–6.
                          </Typography>
                          <br/>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            <Link target="_blank" href="http://flavia.sourceforge.net/" >
                              http://flavia.sourceforge.net/
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel><ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography variant="h4">Beer</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                        <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                          {this.props.language.labels[this.props.language.id].beerMessage1}
                        </Typography>
                        <br/>
                        <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                          {this.props.language.labels[this.props.language.id].beerMessage2}
                          {" "}
                          G. Castellano, C. Castiello, and A. M. Fanelli, "The FISDeT software: Application to beer style classification", in IEEE International Conference
                          on Fuzzy Systems (FUZZ-IEEE), Naples, Italy, 2017, pp. 1–6,{" "}
                          <Link target="_blank" href="https://dx.doi.org/10.1109/FUZZ-IEEE.2017.8015503">
                            https://dx.doi.org/10.1109/FUZZ-IEEE.2017.8015503
                          </Link>
                        </Typography>
                        <br/>
                        <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                          {this.props.language.labels[this.props.language.id].beerMessage3}
                          Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, 2020, pp. 1–8,
                        </Typography>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Vehicle</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].vehicleMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].vehicleMessage2}
                            J. P. Siebert, "Vehicle Recognition Using Rule Based Methods", in Turing Institute Research Memorandum TIRM-87-018, 1987
                          </Typography>
                          <br/>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Vehicle">
                              https://archive.ics.uci.edu/ml/datasets/Vehicle
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Acb</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].acbMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].acbMessage2}
                            Jose M. Alonso, "Explainable Artificial Intelligence for Kids", International Conference of the European Society for Fuzzy Logic and Applications (EUSFLAT), Prague, Czech Republic, pp. 1-8, 2019
                          </Typography>
                          <br/>
                          <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                            <Link target="_blank" href="https://gitlab.citius.usc.es/jose.alonso/basketballplayers-dataset">
                              https://gitlab.citius.usc.es/jose.alonso/basketballplayers-dataset
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                          <Typography variant="h4">Wine</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].wineMessage1}
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].wineMessage2}
                            Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, 2020, pp. 1–8,
                          </Typography>
                          <br/>
                          <Typography variant="body1"  component="p" style={{textAlign: "justify"}}>
                            {this.props.language.labels[this.props.language.id].wineMessage3}
                            An Extendible Package for Data Exploration, Classification and Correlation. Institute of Pharmaceutical and Food Analysis and Technologies, Via Brigata Salerno, 16147 Genoa, Italy.
                          </Typography>
                          <br/>
                          <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                            <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Wine">
                              https://archive.ics.uci.edu/ml/datasets/Wine
                            </Link>
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Grid>
          </Grid>
          <footer className={classes.footer}>
            <Grid container direction="row" alignItems="center" justify={"center"}>
              <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                <img
                    src={galicia}
                    alt="logo turístico galicia"
                    className={classes.leftLogos}
                />
                <img
                    src={xacobeo}
                    alt="logo xacobeo 2021"
                    className={classes.leftLogos}
                />
                <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                <img src={usc} alt="logo usc" className={classes.leftLogos} />
                <img
                    src={campusVida}
                    alt="logo campus vida"
                    className={classes.leftLogos}
                />
              </Grid>
              <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                <img
                    src={ue}
                    alt="logo unión europea"
                    className={classes.rightLogos}
                />
                <img
                    src={xunta}
                    alt="logo xunta de galicia"
                    className={classes.rightLogos}
                />
              </Grid>
            </Grid>
            <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
              {this.props.language.labels[this.props.language.id].fondoEuropeo}
            </Typography>
          </footer>

        </Fragment>
    );
  }
}

Help.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Help);